import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getAllOriginsCategories({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/origins-categories",
        method: "GET",
      });
      let originsCategories = response.data.data;
      commit(MutationsType.SET_ORIGINS_CATEGORIES, originsCategories);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveOriginCategory({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/origins-categories",
        method: "POST",
        data: data,
      });
      commit(MutationsType.ADD_ORIGIN_CATEGORY, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateOriginCategory({ commit, state }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/origins-categories/${id}`,
        method: "PATCH",
        data: data,
      });
      let originCategory = response.data;
      commit(MutationsType.UPDATE_ORIGIN_CATEGORY, originCategory);
      if (originCategory.id === state.originCategory.id) commit(MutationsType.SET_ORIGIN_CATEGORY, originCategory);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async handleOriginCategory({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/origins-categories/${id}`,
        method: "PATCH",
        data: data,
      });
      let originCategory = response.data;
      commit(MutationsType.UPDATE_ORIGIN_CATEGORY, originCategory.data);
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleOriginCategory({ commit }) {
    commit(MutationsType.RESET_ORIGINS_CATEGORIES, null);
  },
};
